module.exports = __webpack_public_path__ + "static/media/trailer.32c676be.svg";